export const numberPattern = "^-?[0-9]*$";
export const numberRegex = new RegExp(numberPattern);
export const stripBr = (s) => {
  return s && s.replace(/<br\/>\n/g, "\n");
};
export const getImageUrl = ({ folderURL, filename, width }) => {
  // The hack below is to solve the following (rare) problem
  // Spin JSONs have filenames  without URI encoding and we don't expect
  // search parameters for spins. But static images might come
  // from any URL. We index into the image store using valid URLS as it may act
  // as a cache and for loading images with progressively increasing
  // resolution in the future. Hence we must encode only the "filename" part
  // but leave the search string as is.
  // Also rare spins have absolute paths in filenames, so we should not encode the slashes
  let encode, dontEncode;
  [encode, dontEncode] = filename.split("?");
  const imageUrl = new URL(sanitizeHash(encodeURI(encode)), folderURL);
  if (dontEncode) {
    imageUrl.search = dontEncode;
  }
  if (width) {
    imageUrl.searchParams.append("w", width);
    imageUrl.searchParams.append("scale.option", "fill");
    imageUrl.searchParams.append("h", "0");
  }
  return imageUrl.toString();
};
export const htmlToReactDangerousInnerHTML = (html) => {
  return {
    __html: html,
  };
};
export const getIntegerKeys = (obj) =>
  Object.keys(obj).map((x) => parseInt(x, 10));
export const convertObjectKeysToInteger = (obj) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [parseInt(k), v]));
export const addOneToKeys = (obj) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [parseInt(k) + 1, v]));
export const isValidPercentage = (v) => v <= 100 && v >= 0;
export const clipToBounds = (x, lower, upper) => {
  if (x < lower) {
    return lower;
  }
  if (x > upper) {
    return upper;
  }
  return x;
};
export const offsetTextByConstant = (text, offset, character = " ") => {
  return text.replaceAll("\n", `\n${character.repeat(offset)}`);
};
export const getFolderURLFromSpinURL = (spinURL) =>
  spinURL.split("/").slice(0, -1).join("/").concat("/");

export const callOnValueChangeFactory = (toCall, initialValue) => {
  //send only when value changes, "edge detector"
  let prevValue = initialValue;
  return (value) => {
    if (value !== prevValue) {
      toCall(value);
      prevValue = value;
    }
  };
};

export function isLocalStorageAvailable() {
  var test = "test";
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

export function tryGetFromStorage(key) {
  if (isLocalStorageAvailable()) {
    return JSON.parse(localStorage.getItem(key));
  }
}

export function trySetInStorage(key, value) {
  if (isLocalStorageAvailable()) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}

export const sanitizeHash = (path) => path.replace(/#/g, "%23");
export const isNullish = (x) => x === undefined || x === null;
export const infoSettingsFrameIndexToLayerFrameObject = (
  infoSettingsFrameIndex,
  N
) => {
  // infoSettingsFrameIndex is 1-based
  if (infoSettingsFrameIndex < 1) {
    throw new Error("infoSettingsFrameIndex cannot be less than 1");
  }
  const zeroBasedFlatFrameIndex = infoSettingsFrameIndex - 1;
  const frame = zeroBasedFlatFrameIndex % N;
  const layer = (zeroBasedFlatFrameIndex - frame) / N;
  return { layer, frame };
};

export function moveToFront(array, i) {
  if (i < 0 || i >= array.length) {
    throw new Error("Index out of bounds");
  }
  return [array[i], ...array.slice(0, i), ...array.slice(i + 1)];
}
